import React, { useEffect } from 'react';
import './leaderboard.css';
import Header from "../../components/Header/Header";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLeaderboardSagaAction } from "../../redux/sagaActions";
import Checkbox from "../../components/Checkbox/Checkbox";
import LeaderboardHeader from "../../components/PagesHeaders/LeaderboardHeader/LeaderboardHeader";

const Leaderboard = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const leaderboard = useSelector(state => state.leaderboard);

    // Получение данных при загрузке компонента
    useEffect(() => {
        dispatch(getLeaderboardSagaAction({ month: leaderboard.month }));
    }, []);

    return (
        <>
           <Header component={ <LeaderboardHeader/> } />
           <div className="page">
               <div className="leaderboard">
                   <div className="table__header">
                       <div className="table__caption">Таблица лидеров</div>
                   </div>
                   <div className="leaderboard__month-year">{ leaderboard.month_year }</div>
                   <div className="leaderboard__period">
                       <div className="leaderboard__period-item">
                           <Checkbox
                               active={ leaderboard.month === 1 }
                               caption={ '1 месяц' }
                               handler={ () => dispatch(getLeaderboardSagaAction({ month: 1 })) }
                           />
                       </div>
                       <div className="leaderboard__period-item">
                           <Checkbox
                               active={ leaderboard.month === 2 }
                               caption={ '2 месяца' }
                               handler={ () => dispatch(getLeaderboardSagaAction({ month: 2 })) }
                           />
                       </div>
                       <div className="leaderboard__period-item">
                           <Checkbox
                               active={ leaderboard.month === 3 }
                               caption={ '3 месяца' }
                               handler={ () => dispatch(getLeaderboardSagaAction({ month: 3 })) }
                           />
                       </div>
                   </div>
                   <div className="table">
                       <div className="table__row table__row--header table__row--leaderboard">
                           <div className="table__cell">Место</div>
                           <div className="table__cell table__cell--left">Посетитель</div>
                           <div className="table__cell">Тренировки</div>
                       </div>
                       {
                           leaderboard.users?.map((elem, index) => {
                               return (
                                   <div className="table__row table__row--leaderboard" key={ elem.user }>
                                       <div className="table__cell">{ index + 1}</div>
                                       <div className="table__cell table__cell--left table__cell--hover"
                                           onClick={ () => {
                                               // Переходим в карточку клиента
                                               history.push('/fitness/users/' + elem.user_id);
                                           } }
                                       >{ elem.user }</div>
                                       <div className="table__cell">{ elem.count }</div>
                                   </div>
                               );
                           })
                       }
                   </div>
               </div>
           </div>
        </>
    );
};

export default Leaderboard;